<template>
  <generic-modal :title="$t('profile')" ref="generic_modal" size="fullscreen">
    <form>
      <!-- Create vertical tabs -->
      <div class="grid">
        <div class="columns">
          <div class="column is-4">
            <aside class="menu">
              <ul class="menu-list">
                <li>
                  <a
                    :class="{ 'is-active': active_tab === 'general' }"
                    @click="active_tab = 'general'"
                    >{{ $t("general") }}</a
                  >
                </li>
                <li>
                  <a
                    :class="{ 'is-active': active_tab === 'disclaimers' }"
                    @click="active_tab = 'disclaimers'"
                    >{{ $t("disclaimers") }}</a
                  >
                </li>
                <!-- <li>
                  <a
                    :class="{ 'is-active': active_tab === 'notifications' }"
                    @click="active_tab = 'notifications'"
                    >{{ $t("notifications") }}</a
                  >
                </li> -->
                <li>
                  <a
                    :class="{
                      'is-active': active_tab === 'messaging_templates',
                    }"
                    @click="active_tab = 'messaging_templates'"
                    >{{ $t("messaging templates") }}</a
                  >
                </li>
                <li>
                  <a
                    :class="{
                      'is-active': active_tab === 'default_values',
                    }"
                    @click="active_tab = 'default_values'"
                    >{{ $t("default values") }}</a
                  >
                </li>
              </ul>
            </aside>
          </div>
          <div class="column">
            <div class="tabs-content">
              <div v-show="active_tab === 'general'">
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <label class="label">{{ $t("logo") }}</label>
                      <div class="control">
                        <!-- Show logo here -->
                        <div
                          class="mt-2"
                          v-if="meta.settings && meta.settings.logo"
                        >
                          <figure class="image is-64x64 mb-2">
                            <img
                              :src="
                                drive_static_file_url(
                                  meta.settings.logo.settings.final_name
                                )
                              "
                              alt="Logo"
                              class="image"
                            />
                          </figure>
                        </div>
                        <generic-uploader
                          ref="logo_uploader"
                          :idle_label="$t('drop logo here')"
                          endpoint_url="/document-sign/profile/logo"
                          @error="error_uploading"
                          @success="success_uploading"
                          :allow_multiple="false"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <label class="label">{{ $t("name") }}</label>
                      <div class="control">
                        <input class="input" type="text" v-model="meta.name" />
                      </div>
                    </div>
                    <div class="field" v-if="meta.settings">
                      <label class="label">{{ $t("expire time") }}</label>
                      <div class="field has-addons" v-if="meta.settings">
                        <div class="control">
                          <input
                            class="input"
                            type="number"
                            v-model="meta.settings.expire_time"
                          />
                        </div>
                        <div class="control">
                          <span class="select"
                            ><select v-model="meta.settings.expire_time_unit">
                              <option value="minute">
                                {{ $t("minutes") }}
                              </option>
                              <option value="hour">{{ $t("hours") }}</option>
                              <option value="day">{{ $t("days") }}</option>
                              <option value="week">{{ $t("weeks") }}</option>
                              <option value="month">{{ $t("months") }}</option>
                            </select>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="field" v-if="meta.settings">
                      <label class="label">{{
                        $t("verification code expire time")
                      }}</label>
                      <div class="field has-addons" v-if="meta.settings">
                        <div class="control">
                          <input
                            class="input"
                            type="number"
                            v-model="
                              meta.settings.verification_code_expire_time
                            "
                          />
                        </div>
                        <div class="control">
                          <span class="select"
                            ><select
                              v-model="
                                meta.settings.verification_code_expire_time_unit
                              "
                            >
                              <option value="minute">
                                {{ $t("minutes") }}
                              </option>
                              <option value="hour">{{ $t("hours") }}</option>
                              <option value="day">{{ $t("days") }}</option>
                              <option value="week">{{ $t("weeks") }}</option>
                              <option value="month">{{ $t("months") }}</option>
                            </select>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <!-- <div class="column" v-if="meta.settings"></div> -->
                  <div class="column" v-if="meta.settings">
                    <div class="field">
                      <label class="label">{{
                        $t("url to redirect on submit request")
                      }}</label>
                      <div class="control">
                        <input
                          class="input"
                          type="text"
                          v-model="meta.settings.redirect_url_sign"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="active_tab === 'disclaimers'">
                <div class="field" v-if="meta.settings">
                  <label class="label">{{
                    $t("disclaimer for reject document")
                  }}</label>
                  <textarea
                    class="textarea"
                    v-model="meta.settings.disclaimer_reject"
                    rows="8"
                  >
                  </textarea>
                </div>
                <div class="field" v-if="meta.settings">
                  <label class="label">{{
                    $t("disclaimer for sign document")
                  }}</label>
                  <textarea
                    class="textarea"
                    v-model="meta.settings.disclaimer_sign"
                    rows="8"
                  >
                  </textarea>
                </div>
              </div>
              <div v-show="active_tab === 'notifications'">
                <div class="columns">
                  <div class="column">
                    <div class="field" v-if="meta.settings">
                      <input
                        class="is-checkradio"
                        type="checkbox"
                        id="chk_notify_on_sign"
                        name="chk_notify_on_sign"
                        v-model="meta.settings.notify_on_sign"
                      />
                      <label for="chk_notify_on_sign">{{
                        $t("notify on document sign")
                      }}</label>
                    </div>
                  </div>
                  <div
                    class="column"
                    v-show="meta.settings && meta.settings.notify_on_sign"
                  >
                    <generic-dropdown
                      :title="$t('outbox template sign document notification')"
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_sign_document_notification_template"
                      ref="document_sign_notification_templates_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    <div class="field" v-if="meta.settings">
                      <input
                        class="is-checkradio"
                        type="checkbox"
                        id="chk_notify_on_expired"
                        name="chk_notify_on_expired"
                        v-model="meta.settings.notify_on_expired"
                      />
                      <label for="chk_notify_on_expired">{{
                        $t("notify on document expired")
                      }}</label>
                    </div>
                  </div>
                  <div
                    class="column"
                    v-show="meta.settings && meta.settings.notify_on_expired"
                  ></div>
                </div>
              </div>
              <div v-show="active_tab === 'messaging_templates'">
                <div class="" v-if="meta.settings">
                  <div class="field">
                    <generic-dropdown
                      :title="$t('new request notification by email')"
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_new_request_notification_email_template"
                      ref="new_request_notification_email_template_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                  <div class="field">
                    <generic-dropdown
                      :title="$t('new request notification by sms')"
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_new_request_notification_sms_template"
                      ref="new_request_notification_sms_template_dropdown"
                      :is_multiple="false"
                    />
                  </div>

                  <div class="field">
                    <generic-dropdown
                      :title="$t('new request notification by whatsapp')"
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_new_request_notification_whatsapp_template"
                      ref="new_request_notification_whatsapp_template_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                  <div class="columns">
                    <div class="column">
                      <generic-dropdown
                        :title="$t('submit administrative email template')"
                        :placeholder="$t('select one')"
                        url="/outbox/template/catalog"
                        name_field="name"
                        value_field="template_id"
                        @selected="set_submit_email_template"
                        ref="submit_email_template_dropdown"
                        :is_multiple="false"
                      />
                    </div>
                    <div class="column">
                      <label class="label">{{
                        $t("notify email on submit request")
                      }}</label>
                      <div class="control">
                        <input
                          class="input"
                          type="text"
                          v-model="meta.settings.notify_email"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <generic-dropdown
                      :title="$t('outbox template sign document notification')"
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_sign_document_notification_template"
                      ref="document_sign_notification_templates_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                  <div class="field">
                    <generic-dropdown
                      :title="
                        $t('outbox template expired document notification')
                      "
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_expire_document_notification_template"
                      ref="document_expire_notification_templates_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                  <div class="field">
                    <generic-dropdown
                      :title="
                        $t('outbox template sms code verification message')
                      "
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_sms_code_verification_template"
                      ref="sms_code_verification_templates_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                  <div class="field">
                    <generic-dropdown
                      :title="
                        $t('outbox template email code verification message')
                      "
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_email_code_verification_template"
                      ref="email_code_verification_templates_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                  <div class="field">
                    <generic-dropdown
                      :title="
                        $t('outbox template whatsapp code verification message')
                      "
                      :placeholder="$t('select one')"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @selected="set_whatsapp_code_verification_template"
                      ref="whatsapp_code_verification_templates_dropdown"
                      :is_multiple="false"
                    />
                  </div>
                </div>
              </div>
              <div v-show="active_tab === 'default_values'">
                <div v-if="meta.settings" class="box">
                  <!-- Communication Options -->
                  <div class="field">
                    <h6 class="subtitle is-6 mb-3">
                      <span class="icon">
                        <i class="fa fa-comments"></i>
                      </span>
                      {{ $t("communication methods") }}
                    </h6>

                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <input
                            class="is-checkradio"
                            type="checkbox"
                            id="chk_send_email"
                            name="chk_send_email"
                            v-model="meta.settings.default_send_email"
                          />
                          <label for="chk_send_email">
                            <span class="icon is-small">
                              <i class="fa fa-envelope"></i>
                            </span>
                            {{ $t("send email") }}
                          </label>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <input
                            class="is-checkradio"
                            type="checkbox"
                            id="chk_send_sms"
                            name="chk_send_sms"
                            v-model="meta.settings.default_send_sms"
                          />
                          <label for="chk_send_sms">
                            <span class="icon is-small">
                              <i class="fa fa-phone"></i>
                            </span>
                            {{ $t("send sms") }}
                          </label>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <input
                            class="is-checkradio"
                            type="checkbox"
                            id="chk_send_whatsapp"
                            name="chk_send_whatsapp"
                            v-model="meta.settings.default_send_whatsapp"
                          />
                          <label for="chk_send_whatsapp">
                            <span class="icon is-small">
                              <i class="fa fa-whatsapp"></i>
                            </span>
                            {{ $t("send whatsapp") }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Verification Options -->
                  <div class="field">
                    <h6 class="subtitle is-6 mb-3">
                      <span class="icon">
                        <i class="fa fa-shield"></i>
                      </span>
                      {{ $t("verification options") }}
                    </h6>

                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <input
                            class="is-checkradio"
                            type="checkbox"
                            id="chk_run_onfido"
                            name="chk_run_onfido"
                            v-model="meta.settings.default_run_onfido"
                          />
                          <label for="chk_run_onfido">
                            <span class="icon is-small">
                              <i class="fa fa-id-badge"></i>
                            </span>
                            {{ $t("run onfido") }}
                          </label>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <input
                            class="is-checkradio"
                            type="checkbox"
                            id="chk_reproduce_video"
                            name="chk_reproduce_video"
                            v-model="meta.settings.default_reproduce_video"
                          />
                          <label for="chk_reproduce_video">
                            <span class="icon is-small">
                              <i class="fa fa-play"></i>
                            </span>
                            {{ $t("reproduce video") }}
                          </label>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <label class="label">
                            <span class="icon is-small">
                              <i class="fa fa-lock"></i>
                            </span>
                            {{ $t("security method") }}
                          </label>
                          <div class="control">
                            <div class="select is-fullwidth">
                              <select
                                v-model="meta.settings.default_security_method"
                              >
                                <option value="none">{{ $t("none") }}</option>
                                <option value="sms-code">
                                  {{ $t("sms code") }}
                                </option>
                                <option value="email-code">
                                  {{ $t("email code") }}
                                </option>
                                <option value="whatsapp-code">
                                  {{ $t("whatsapp code") }}
                                </option>
                                <option value="dpi">{{ $t("dpi") }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Flow -->
                  <div class="field">
                    <h6 class="subtitle is-6 mb-3">
                      <span class="icon">
                        <i class="fa fa-shield"></i>
                      </span>
                      {{ $t("flow options") }}
                    </h6>

                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label">
                            <span class="icon is-small">
                              <i class="fa fa-arrow-right"></i>
                            </span>
                            {{ $t("default flow") }}
                          </label>
                          <div class="control">
                            <div class="select is-fullwidth">
                              <select v-model="meta.settings.default_flow">
                                <option
                                  value="capture-verification-documentation"
                                >
                                  {{ $t("capture-verification-documentation") }}
                                </option>
                                <option
                                  value="capture-documentation-verification"
                                >
                                  {{ $t("capture-documentation-verification") }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="column"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  drive_static_file_url,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "EntityModal",
  components: { GenericModal, GenericUploader, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
      active_tab: "general", // Default active tab
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    drive_static_file_url,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/account-request/entity", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();

          if (
            element.settings.outbox_template_id_document_send &&
            v.$refs.templates_dropdown
          )
            v.$refs.templates_dropdown.set_value(
              element.settings.outbox_template_id_document_send
            );

          if (
            element.settings.outbox_template_id_document_sign_notification &&
            v.$refs.document_sign_notification_templates_dropdown
          )
            v.$refs.document_sign_notification_templates_dropdown.set_value(
              element.settings.outbox_template_id_document_sign_notification
            );

          if (
            element.settings.outbox_template_id_document_expired_notification &&
            v.$refs.document_expire_notification_templates_dropdown
          )
            v.$refs.document_expire_notification_templates_dropdown.set_value(
              element.settings.outbox_template_id_document_expired_notification
            );

          if (
            element.settings
              .outbox_template_id_new_request_notification_email &&
            v.$refs.new_request_notification_email_template_dropdown
          )
            v.$refs.new_request_notification_email_template_dropdown.set_value(
              element.settings.outbox_template_id_new_request_notification_email
            );
          if (
            element.settings.outbox_template_id_new_request_notification_sms &&
            v.$refs.new_request_notification_sms_template_dropdown
          )
            v.$refs.new_request_notification_sms_template_dropdown.set_value(
              element.settings.outbox_template_id_new_request_notification_sms
            );
          if (
            element.settings
              .outbox_template_id_new_request_notification_whatsapp &&
            v.$refs.new_request_notification_whatsapp_template_dropdown
          )
            v.$refs.new_request_notification_whatsapp_template_dropdown.set_value(
              element.settings
                .outbox_template_id_new_request_notification_whatsapp
            );

          if (
            element.settings.outbox_template_id_document_submit &&
            v.$refs.submit_email_template_dropdown
          )
            v.$refs.submit_email_template_dropdown.set_value(
              element.settings.outbox_template_id_document_submit
            );

          if (
            element.settings.outbox_template_id_sms_code_verification &&
            v.$refs.sms_code_verification_templates_dropdown
          )
            v.$refs.sms_code_verification_templates_dropdown.set_value(
              element.settings.outbox_template_id_sms_code_verification
            );

          if (
            element.settings.outbox_template_id_email_code_verification &&
            v.$refs.email_code_verification_templates_dropdown
          )
            v.$refs.email_code_verification_templates_dropdown.set_value(
              element.settings.outbox_template_id_email_code_verification
            );

          if (
            element.settings.outbox_template_id_whatsapp_code_verification &&
            v.$refs.whatsapp_code_verification_templates_dropdown
          )
            v.$refs.whatsapp_code_verification_templates_dropdown.set_value(
              element.settings.outbox_template_id_whatsapp_code_verification
            );
        })
        .catch((error) => {
          console.error(error);
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/account-request/entity", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/account-request/entity", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
      if (v.$refs.logo_uploader) v.$refs.logo_uploader.clear();
      if (v.$refs.templates_dropdown) v.$refs.templates_dropdown.clear();
      if (v.$refs.document_sign_notification_templates_dropdown)
        v.$refs.document_sign_notification_templates_dropdown.clear();
      if (v.$refs.document_expire_notification_templates_dropdown)
        v.$refs.document_expire_notification_templates_dropdown.clear();
      if (v.$refs.new_request_notification_email_template_dropdown)
        v.$refs.new_request_notification_email_template_dropdown.clear();
      if (v.$refs.new_request_notification_sms_template_dropdown)
        v.$refs.new_request_notification_sms_template_dropdown.clear();
      if (v.$refs.new_request_notification_whatsapp_template_dropdown)
        v.$refs.new_request_notification_whatsapp_template_dropdown.clear();
      if (v.$refs.submit_email_template_dropdown)
        v.$refs.submit_email_template_dropdown.clear();
      if (v.$refs.sms_code_verification_templates_dropdown)
        v.$refs.sms_code_verification_templates_dropdown.clear();
      if (v.$refs.email_code_verification_templates_dropdown)
        v.$refs.email_code_verification_templates_dropdown.clear();
      if (v.$refs.whatsapp_code_verification_templates_dropdown)
        v.$refs.whatsapp_code_verification_templates_dropdown.clear();
      v.active_tab = "general";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      v.$refs.logo_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      v.meta.settings.logo = rspnse;
    },
    set_new_request_notification_email_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_new_request_notification_email =
          template.template_id;
    },
    set_new_request_notification_sms_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_new_request_notification_sms =
          template.template_id;
    },
    set_new_request_notification_whatsapp_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_new_request_notification_whatsapp =
          template.template_id;
    },
    set_submit_email_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_document_submit =
          template.template_id;
    },
    set_sign_document_notification_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_document_sign_notification =
          template.template_id;
    },
    set_expire_document_notification_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_document_expired_notification =
          template.template_id;
    },
    set_sms_code_verification_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_sms_code_verification =
          template.template_id;
    },
    set_email_code_verification_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_email_code_verification =
          template.template_id;
    },
    set_whatsapp_code_verification_template(template) {
      let v = this;
      if (template)
        v.meta.settings.outbox_template_id_whatsapp_code_verification =
          template.template_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
